import { omit } from 'lodash'
import * as types from '../common/types'
import createReducer from './createReducer'

const initialState = {}

export const modals = createReducer(initialState, {
  [types.OPEN_MODAL](state, { modalId, data }) {
    return {
      ...state,
      [modalId]: {
        isOpen: true,
        ...data
      }
    }
  },
  [types.CLOSE_MODAL](state, { modalId }) {
    return omit(state, [modalId])
  }
})
